export default "__VITE_ASSET__DSKzqOAl__"